<app-left-menu></app-left-menu>
<div id="main-container">

    <app-header [title]="title" [showAddLacationsButton]=true></app-header>

    <div class="content-header" style="margin-top: 70px;">

        <ul class="nav nav-tabs content" role="tablist">
            <li role="presentation" class="active"><a href="#currentLacations" role="tab" data-toggle="tab"
                    aria-expanded="true">{{'Locations.Tabs.MailingandBillingAddress' | translate}}
                </a>
            </li>
            <li role="presentation"><a href="#pastLacations" role="tab" data-toggle="tab"
                    aria-expanded="false">{{'Locations.Tabs.ProviderSite' | translate}}</a>
            </li>

        </ul>
    </div>
    <div class="page-content">

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="mailingandBillingAddress">
                <form [formGroup]="mailingAddressForm"
                    (submit)="submit(mailingAddressForm.value,mailingAddressForm.valid)">

                    <div class="col-md-6">
                        <label>{{'MailingAddress.MailingAddressLine1.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="256" formControlName="MailingAddressLine1">

                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.MailingAddressLine2.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="256" formControlName="MailingAddressLine2">

                    </div>



                    <div class="col-md-6">
                        <label>{{'MailingAddress.City.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="50" formControlName="City">

                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.State.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="50" formControlName="State">

                    </div>

                    <div class="col-md-6">

                        <label>{{'MailingAddress.Zipcode.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="9" formControlName="Zipcode">
                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.Contact.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" mask="000-000-0000" formControlName="Contact">

                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.Fax.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" mask="000-000-0000" formControlName="Fax">

                    </div>
                    <div class="col-md-12">

                        <button type="submit" class="btn btn-main"
                            [disabled]="!mailingAddressForm.valid">{{'Common.Submit'|translate}}</button>
                    </div>
                </form>
                <input type="checkbox"
                    [(ngModel)]="sameAsMailingAddress" /><label>{{'Location.Label.SameAsBillingAddress'|translate}}</label>
                <form  [formGroup]="billingAddressForm"
                    (submit)="submit(billingAddressForm.value,billingAddressForm.valid)">

                    <div class="col-md-6">
                        <label>{{'MailingAddress.MailingAddressLine1.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" [readonly]="sameAsMailingAddress" maxlength="256" formControlName="MailingAddressLine1">

                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.MailingAddressLine2.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" maxlength="256" formControlName="MailingAddressLine2">

                    </div>



                    <div class="col-md-6">
                        <label>{{'MailingAddress.City.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" maxlength="50" formControlName="City">
 
                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.State.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" maxlength="50" formControlName="State">

                    </div>

                    <div class="col-md-6">

                        <label>{{'MailingAddress.Zipcode.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" maxlength="9" formControlName="Zipcode">
                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.Contact.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" mask="000-000-0000" formControlName="Contact">

                    </div>
                    <div class="col-md-6">
                        <label>{{'MailingAddress.Fax.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input [readonly]="sameAsMailingAddress" type="text" mask="000-000-0000" formControlName="Fax">

                    </div>
                    <div class="col-md-12">

                        <button type="submit" class="btn btn-main"
                            [disabled]="!mailingAddressForm.valid">{{'Common.Submit'|translate}}</button>
                    </div>
                </form>


            </div>
            <div role="tabpanel" class="tab-pane " id="providerSites">

                <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                <table *ngIf="providerSites?.length>0" class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th>{{' Lacations.Table.Header.AddressLine1' | translate}}</th>
                            <th> {{'Lacations.Table.Header.ContactNo' | translate}}</th>
                            <th> {{'Lacations.Table.Header.Zipcode'| translate}}</th>
                            <th>{{' Lacations.Table.Header.City' | translate}}</th>
                            <th> {{'Lacations.Table.Header.State' | translate}}</th>
                            <th> {{'Lacations.Table.Header.Description'| translate}}</th>
                            <th style="text-align: center"> {{'Common.Action'| translate}}</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr [class.alternate]="i%2!=0" *ngFor="let item of providerSites; index as i;">

                            <td style="width: 200px;">{{item.AddressLine1 | date:'MM/dd/yyyy'}}</td>
                            <td style="width: 200px;">{{item.ContactNo | date:'MM/dd/yyyy'}}</td>
                            <td style="width: 200px;">{{item.Zipcode}}</td>
                            <td style="width: 200px;">{{item.City }}</td>
                            <td style="width: 200px;">{{item.State}}</td>
                            <td style="width: 200px;">{{item.Description}}</td>
                            <td style="width: 50px;text-align: center;"> <a href="javascript:void(0)"
                                    (click)="changeSiteStatus(item.ProviderSiteId)">{{item.Status==1?'Locations.Links.Activate':'Locations.Links.DeActivate'}}</a>
                                &nbsp;|&nbsp; <a [routerLink]="['/Lacations/edit',item.ProviderStatusId]"
                                    routerLinkActive="router-link-active"
                                    href="javascript:void(0)">{{'Common.Edit'|translate}}</a></td>
                        </tr>
                    </tbody>
                </table>
                <div class="not-found" *ngIf="providerSites?.length==''">{{'Lacations.NoRecord.Current'|translate}}
                </div>

            </div>
        </div>

    </div>

</div>